export default __webpack_public_path__ + "static/media/deleteIcon.c53e62cd.svg";